// Volo.Abp.Identity.IdentityPermissions.Users.
export const IdentityUserPermissions = {
  view: 'AbpIdentity.Users',
  create: 'AbpIdentity.Users.Create',
  update: 'AbpIdentity.Users.Update',
  delete: 'AbpIdentity.Users.Delete',
  managePermissions: 'AbpIdentity.Users.ManagePermissions',
} as const;
